import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "max-w-[85%] rounded-xl border border-primary-100 bg-primary-50 p-4"
};
const _hoisted_2 = {
  key: 0,
  class: "mt-2 rounded-lg bg-white/70 p-2"
};
import { computed } from 'vue';
export default {
  __name: 'DialogueCard',
  props: {
    snapshot: {
      type: Object,
      required: true
    },
    pending: {
      type: Boolean,
      default: false
    }
  },
  emits: ['resume'],
  setup(__props) {
    const props = __props;
    const payload = computed(() => props.snapshot && props.snapshot.interrupt_payload || {});
    const collected = computed(() => Object.entries(payload.value.extracted_so_far || {}));
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_cache[1] || (_cache[1] = _createElementVNode("p", {
        class: "text-sm font-medium text-primary-800"
      }, "申报助手 · 待回答", -1)), collected.value.length ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_cache[0] || (_cache[0] = _createElementVNode("p", {
        class: "text-xs text-slate-400"
      }, "已采集到：", -1)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(collected.value, ([k, v]) => {
        return _openBlock(), _createElementBlock("p", {
          key: k,
          class: "text-xs text-slate-600"
        }, _toDisplayString(k) + "：" + _toDisplayString(v), 1);
      }), 128))])) : _createCommentVNode("", true), _cache[2] || (_cache[2] = _createElementVNode("p", {
        class: "mt-2 text-xs text-slate-400"
      }, "请在下方输入框回答上方问题；也可等待转为逐字段填写", -1))]);
    };
  }
};